/**
 * REVELL FLOWERS LANDING PAGE - INTERACTIVE FEATURES
 */

class FlowersLanding {
  constructor() {
    this.init();
  }

  init() {
    this.initHero();
    this.initVideo();
    this.initScrollAnimations();
  }

  /**
   * HERO SECTION - Floating Flowers Animation
   */
  initHero() {
    const hero = document.querySelector('.flowers-hero');
    if (!hero) return;

    // Add floating flowers if not already present
    const floatingContainer = hero.querySelector('.floating-flowers');
    if (floatingContainer && floatingContainer.children.length === 0) {
      const flowers = ['🌸', '🌺', '🌼', '🌻'];
      for (let i = 0; i < 4; i++) {
        const flower = document.createElement('div');
        flower.className = 'floating-flower';
        flower.textContent = flowers[i];
        floatingContainer.appendChild(flower);
      }
    }
  }

  /**
   * VIDEO SECTION - Play/Pause Control
   */
  initVideo() {
    const videoSections = document.querySelectorAll('[data-section-type="flowers-video"]');
    
    videoSections.forEach(section => {
      const wrapper = section.querySelector('.video-wrapper');
      const playButton = section.querySelector('.video-play-button');
      const video = section.querySelector('video');
      const iframe = section.querySelector('iframe');
      
      if (!wrapper) return;
      
      if (playButton) {
        playButton.addEventListener('click', () => {
          wrapper.classList.add('playing');
          
          if (video) {
            video.play();
          } else if (iframe) {
            // For YouTube/Vimeo iframes, try to trigger play via postMessage
            const src = iframe.src;
            if (src.includes('youtube.com')) {
              iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
            } else if (src.includes('vimeo.com')) {
              iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
            }
          }
        });
      }
      
      if (video) {
        video.addEventListener('ended', () => {
          wrapper.classList.remove('playing');
        });
        
        video.addEventListener('pause', () => {
          wrapper.classList.remove('playing');
        });
      }
    });
  }

  /**
   * SCROLL ANIMATIONS - Fade in elements on scroll
   */
  initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Animate feature cards
    const featureCards = document.querySelectorAll('.feature-card');
    featureCards.forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(40px)';
      card.style.transition = `all 0.6s ease ${index * 0.1}s`;
      observer.observe(card);
    });
    
    // Animate product cards
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(40px)';
      card.style.transition = `all 0.6s ease ${index * 0.15}s`;
      observer.observe(card);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FlowersLanding();
  });
} else {
  new FlowersLanding();
}
